import React from "react";
import { Container, Button } from "shards-react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === "development") {
      console.error("ErrorBoundary caught an error:", error, errorInfo);
    }
    // In production, set REACT_APP_ERROR_REPORTING_URL so errors are sent to your backend or logging service (see env/.env.example)
    const reportingUrl = process.env.REACT_APP_ERROR_REPORTING_URL;
    if (reportingUrl && typeof fetch !== "undefined") {
      const payload = {
        message: error && error.message ? String(error.message).slice(0, 500) : "Unknown error",
        componentStack: errorInfo && errorInfo.componentStack ? String(errorInfo.componentStack).slice(0, 1000) : undefined,
      };
      fetch(reportingUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => {});
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    const basePath = process.env.REACT_APP_SUB_DOMAIN || "";
    window.location.href = basePath + "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-fullpage" role="alert" aria-live="assertive">
          <Container fluid className="main-content-container px-4 pb-4">
            <div className="error error-boundary-friendly">
              <div className="error__content">
                <h2>Something went wrong</h2>
                <p>An unexpected error occurred. Please try again or return to the home page.</p>
                <div className="mt-3">
                  <Button pill className="mr-2" onClick={this.handleRetry}>
                    Try again
                  </Button>
                  <Button pill theme="light" onClick={this.handleGoHome}>
                    Go to home
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
